import { onBeforeUnmount, ref } from "@vue/composition-api";
import { scrileConnect as ProvidersFactory } from "@scrile/api-provider";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { closeAdditionalProvidersConnection, getAdditionalProviders, ProviderPrefix } from "@/lib/api";

export default function useAdditionalProviders(prefix: ProviderPrefix) {
  const providers = ref<ReturnType<typeof ProvidersFactory>>();
  const longLiveToken = ref<string>();
  const user = ref<User | null>(null);
  const authorities = ref<string[]>([]);

  const getTokens = async () => {
    if (!providers.value) providers.value = getAdditionalProviders(prefix);
    longLiveToken.value = await providers.value.providers.LoginProvider.getLongLiveToken();
  };

  const login = async () => {
    if (longLiveToken.value && providers.value) {
      // providers.value.providers.LoginProvider.setReceiveErrors(false);
      const response = await providers.value.providers.LoginProvider.refreshTokenV2({
        token: longLiveToken.value,
      });
      user.value = response.user;
      authorities.value = response.authorities ?? [];
    }
  };

  const setToken = async (token: string) => {
    if (!providers.value) return;
    longLiveToken.value = token;
    return providers.value.providers.LoginProvider.setLongLiveToken(longLiveToken.value);
  };

  const closeConnection = () => {
    providers.value = longLiveToken.value = undefined;
    user.value = null;
    authorities.value = [];
    closeAdditionalProvidersConnection(prefix);
  };

  onBeforeUnmount(() => {
    providers.value && closeAdditionalProvidersConnection(prefix);
  });

  return {
    providers,
    user,
    authorities,
    longLiveToken,
    getTokens,
    setToken,
    login,
    closeConnection,
  };
}
